import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { ApiurlsService } from '../../../services/api-urls/apiurls.service';
import { ApirequestService } from '../../../services/apirequest/apirequest.service';

@Component({
  selector: 'hybse-admin-partner-transaction-details',
  templateUrl: './partner-transaction-details.component.html',
  styleUrls: ['./partner-transaction-details.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class PartnerTransactionDetailsComponent implements OnInit {
  public showLoader: boolean = true;
  public fadeInDown: any;
  public partnerTransactionList: any[] = [];
  public errorMessage: string;
  constructor(
    private _urls: ApiurlsService,
    private _api: ApirequestService
  ) { }

  ngOnInit() {
    this.getPartnerTransactionList();
  }
  getPartnerTransactionList() {
    this.showLoader = true;
    this._api.fetchApiData(this._urls.partnerTxnLogUrl, {}).subscribe(
      (data: any) => {
        let resSucc = data.data;
        let resError = data.error;
        if (resSucc != '') this.partnerTransactionList = resSucc;
        if (resError != '') {
          this.errorMessage = resError.errorDescription;
          console.log(this.errorMessage);
        }
      },
      error => { },
      () => {
        this.showLoader = false;
      }
    )
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/partner/partner-transaction-details.component.ts